import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { fadeInOut } from '@helpers/fadeInOut';
import { OpsAlarmMonitoringService } from '@service/ops-alarms/ops-alarm-monitoring.service';
import { OpsAlarmsPageService } from '@service/ops-alarms/ops-alarm.service';
import { ResponsiveService } from '@service/responsive.service';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-alarm-window',
    templateUrl: './alarm-window.component.html',
    styleUrls: ['./alarm-window.component.scss'],
    animations: [fadeInOut],
    standalone: false
})
export class AlarmWindowComponent implements OnInit, OnDestroy {
    @Input() alarms: AlarmMonitoring[] = [];
    @Input() alarmWindowMoreNumber: number;
    @Input() alarmIndex: number;
    @Output() alarmWindowCloseEvent = new EventEmitter();
    @Output() previousAlarmEvent = new EventEmitter();
    @Output() nextAlarmEvent = new EventEmitter();

    @ViewChild('alarmWindow') public alarmWindow: ElementRef;

    private oustideCompClickListener;
    private isVisible: boolean = false;

    currentIndex = 0;
    alarm: AlarmMonitoring;
    newAlarmSubscription: Subscription;

    constructor(
        private alarmMonitoringService: OpsAlarmMonitoringService,
        private opsAlarmsPageService: OpsAlarmsPageService,
        private router: Router,
        private ngZone: NgZone,
        private renderer: Renderer2,
        public responsive: ResponsiveService,
    ) {}

    ngOnInit(): void {
        this.oustideCompClickListener = this.renderer.listen(
            'document',
            'click',
            (event: MouseEvent) => {
                this.handleClick(event);
            },
        );
    }

    ngOnDestroy(): void {
        this.oustideCompClickListener();
    }

    clickShowMore() {
        this.ngZone.run(() => this.navigateTo('/ops/alarms'));
        this.alarmWindowCloseEvent.emit();
        this.opsAlarmsPageService.openAlarmMonitoringPage();
    }

    navigateTo(url: string) {
        this.router.navigate([url]);
    }

    private handleClick(mouseEvent) {
        if (!this.alarmWindow.nativeElement.contains(mouseEvent.target)) {
            if (this.isVisible) {
                this.alarmWindowCloseEvent.emit();
                return;
            }
            this.isVisible = true;
        }
    }

    public onClickAck(alarmData: AlarmMonitoring) {
        this.alarmMonitoringService.ackAlarm(alarmData);
    }

    public shouldDisableButton(alarm: AlarmMonitoring) {
        return !alarm.UnAck || this.alarmMonitoringService.isAckInProgress(alarm) || this.alarmMonitoringService.isBuzzerActive();
    }

    public getAlarmWindowMore() {
        return this.alarms.length;
    }

    public onAlarmNext() {
        this.nextAlarmEvent.emit();
    }

    public onAlarmPrevious() {
        this.previousAlarmEvent.emit();
    }
}
